export interface IFgtsMargin {
  id?: string;
  consult_date_time?: string;
  document?: string;
  available_fgts_guarantee_balance?: number;
  severance_fine_fgts_guarantee?: number;
  message?: string;
}

export const hasFgtsGuaranteeBalanceResponse = (
  fgtsMargin?: IFgtsMargin,
): boolean => {
  if (!fgtsMargin) {
    return false;
  }

  return (
    fgtsMargin.available_fgts_guarantee_balance != null ||
    fgtsMargin.severance_fine_fgts_guarantee != null
  );
};

export type TLoanGuaranteeFormValues = {
  guarantee_balance_fgts_id?: string;
  hasRescissionPenalty: boolean;
  rescissionPenaltyPercent: string;
  hasFgtsBalanceGuarantee: boolean;
  fgtsBalanceAmount: string;
  hasFgtsRescissionPenalty: boolean;
  fgtsRescissionPenaltyAmount: string;
};

export type TApplicationGuaranteeInfoPayload = {
  guarantee_balance_fgts_id?: string;
  available_fgts_guarantee_balance?: number;
  severance_fine_fgts_guarantee?: number;
  available_rescission_allowance_percent?: number;
};

export const buildGuaranteeInfoPayload = (
  fgtsMargin?: IFgtsMargin,
  formValues?: TLoanGuaranteeFormValues,
): TApplicationGuaranteeInfoPayload | undefined => {
  if (!formValues) {
    return undefined;
  }

  const hasAnyGuaranteeSelected =
    formValues.hasRescissionPenalty ||
    formValues.hasFgtsBalanceGuarantee ||
    formValues.hasFgtsRescissionPenalty;

  if (!hasAnyGuaranteeSelected) {
    return undefined;
  }

  const payload: TApplicationGuaranteeInfoPayload = {};

  if (formValues.hasFgtsBalanceGuarantee && formValues.fgtsBalanceAmount) {
    payload.available_fgts_guarantee_balance =
      Number(formValues.fgtsBalanceAmount.replace(/\D/g, '')) / 100;
  }

  if (
    formValues.hasFgtsRescissionPenalty &&
    formValues.fgtsRescissionPenaltyAmount
  ) {
    payload.severance_fine_fgts_guarantee =
      Number(formValues.fgtsRescissionPenaltyAmount.replace(/\D/g, '')) / 100;
  }

  if (formValues.hasRescissionPenalty && formValues.rescissionPenaltyPercent) {
    payload.available_rescission_allowance_percent = parseFloat(
      formValues.rescissionPenaltyPercent.replace(',', '.'),
    );
  }

  const requiresFgtsBalanceId =
    payload.available_fgts_guarantee_balance != null ||
    payload.severance_fine_fgts_guarantee != null;

  if (requiresFgtsBalanceId) {
    const guaranteeBalanceFgtsId =
      formValues.guarantee_balance_fgts_id || fgtsMargin?.id;

    if (guaranteeBalanceFgtsId) {
      payload.guarantee_balance_fgts_id = guaranteeBalanceFgtsId;
    }
  }

  if (
    !payload.guarantee_balance_fgts_id &&
    payload.available_fgts_guarantee_balance == null &&
    payload.severance_fine_fgts_guarantee == null &&
    payload.available_rescission_allowance_percent == null
  ) {
    return undefined;
  }

  return payload;
};

export const defaultLoanGuaranteeFormValues: TLoanGuaranteeFormValues = {
  guarantee_balance_fgts_id: '',
  hasRescissionPenalty: false,
  rescissionPenaltyPercent: '',
  hasFgtsBalanceGuarantee: false,
  fgtsBalanceAmount: '',
  hasFgtsRescissionPenalty: false,
  fgtsRescissionPenaltyAmount: '',
};
